import {
  // BOOKINGS LIST ACTIONS - FETCH AND SAVE BOOKINGS
  SAVE_KEG_COLLECTION_BOOKINGS,
  FETCH_KEG_COLLECTION_BOOKINGS_REQUEST,
  FETCH_KEG_COLLECTION_BOOKINGS_SUCCESS,
  FETCH_KEG_COLLECTION_BOOKINGS_FAILURE,
  KEG_COLLECTION_BOOKINGS_CURRENT_REQUEST_ID,
  // BOOKINGS LIST VIEW SEARCH FILTER OPTIONS ACTION TYPES - FETCH AND SAVE SEARCH FILTER OPTIONS
  SAVE_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS,
  FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_REQUEST,
  FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_SUCCESS,
  FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_FAILURE,
  // EXPORTED BOOKINGS LIST TO CSV
  SAVE_EXPORTED_KEG_COLLECTION_BOOKINGS_CSV_FILE,
  FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_REQUEST,
  FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_SUCCESS,
  FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_FAILURE,
  RESET_EXPORTED_KEG_COLLECTION_BOOKINGS_CSV_FILE,
  // SINGLE BOOKING ACTIONS - FETCH AND SAVE SINGLE BOOKING
  SAVE_SINGLE_KEG_COLLECTION_BOOKING,
  FETCH_SINGLE_KEG_COLLECTION_BOOKING_REQUEST,
  FETCH_SINGLE_KEG_COLLECTION_BOOKING_SUCCESS,
  FETCH_SINGLE_KEG_COLLECTION_BOOKING_FAILURE,
  // EDIT BOOKING ACTIONS - FETCH AND SAVE SINGLE EDITED BOOKING
  SAVE_EDITED_KEG_COLLECTION_BOOKING,
  EDIT_KEG_COLLECTION_BOOKING_REQUEST,
  EDIT_KEG_COLLECTION_BOOKING_SUCCESS,
  EDIT_KEG_COLLECTION_BOOKING_FAILURE,
  // CREATE KEG COLLECTION REQUEST ACTION TYPES - CREATE A KEG COLLECTION REQUEST
  CREATE_KEG_COLLECTION_REQUEST,
  CREATE_KEG_COLLECTION_SUCCESS,
  CREATE_KEG_COLLECTION_FAILURE,
  RESET_CREATE_KEG_COLLECTION_STATUS_STATE,
  // EDIT KEG COLLECTION REQUEST ACTION TYPES - EDIT A SINGLE KEG COLLECTION REQUEST
  SAVE_EDITED_KEG_COLLECTION,
  EDIT_KEG_COLLECTION_REQUEST_,
  EDIT_KEG_COLLECTION_REQUEST_SUCCESS,
  EDIT_KEG_COLLECTION_REQUEST_FAILURE,
  RESET_EDIT_KEG_COLLECTION_REQUEST_STATUS_STATE,
  // DELETE KEG COLLECTION REQUEST ACTION TYPES - DELETE A SINGLE KEG COLLECTION REQUEST
  DELETE_KEG_COLLECTION_REQUEST,
  DELETE_KEG_COLLECTION_SUCCESS,
  DELETE_KEG_COLLECTION_FAILURE,
  RESET_DELETE_KEG_COLLECTION_STATUS_STATE,
  // COLLECTOR LIST ACTION TYPES - FETCH AND SAVE COLLECTORS LIST
  SAVE_KEG_COLLECTION_BOOKING_COLLECTORS,
  FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_REQUEST,
  FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_SUCCESS,
  FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_FAILURE,
  RESET_EDITED_BOOKING_STATUS_STATE,
  // VENUE LIST ACTION TYPES - FETCH AND SAVE VENUES LIST
  FETCH_KEG_COLLECTION_BOOKING_VENUES_REQUEST,
  FETCH_KEG_COLLECTION_BOOKING_VENUES_SUCCESS,
  FETCH_KEG_COLLECTION_BOOKING_VENUES_FAILURE,
  SAVE_KEG_COLLECTION_BOOKING_VENUES,
  // VENUE COLLECTION INFO ACTION TYPES - FETCH AND SAVE VENUE COLLECTION INFO
  SAVE_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO,
  FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_REQUEST,
  FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_SUCCESS,
  FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_FAILURE,
  // BOOKINGS GENERAL NOTIFICATION MESSAGE ACTION TYPES - SET AND UNSET GENERAL NOTIFICATION MESSAGE
  SHOW_BOOKINGS_GENERAL_NOTIFICATION_MESSAGE,
  HIDE_BOOKINGS_GENERAL_NOTIFICATION_MESSAGE,
  // BOOKINGS MODAL ERROR BANNER ACTION TYPES - SET AND UNSET MODAL ERROR BANNER MESSAGE
  SHOW_BOOKINGS_MODAL_ERROR_MESSAGE,
  HIDE_BOOKINGS_MODAL_ERROR_MESSAGE,
} from '../actions/actionTypes'

const initialState = {
  bookingsList: {
    isFetching: false,
    didFetchFail: false,
    didFetchSucceed: false,
    content: [],
    pageNumber: 1,
    pageSize: 10,
    totalElements: 0,
    totalPages: 0,
    fetchedAt: null,
    lastParams: null,
    currentRequestId: null,
  },
  bookingsListViewSearchFilterOptions: {
    isFetching: false,
    didFetchFail: false,
    didFetchSucceed: false,
    content: { createdByUsers: [], assignedByUsers: [], states: [], postalCodes: [] },
  },
  bookingsExportList: {
    isFetching: false,
    didFetchFail: false,
    didFetchSucceed: false,
    content: [],
    fetchedAt: null,
    lastParams: null,
  },
  bookingDetails: {
    bookingData: {
      content: null,
      isFetching: false,
      didFetchFail: false,
      didFetchSucceed: false,
      isEditing: false,
      didEditSucceed: false,
      didEditFail: false,
    },
    editKegCollectionRequestStatusState: {
      isEditing: false,
      didEditSucceed: false,
      didEditFail: false,
    },
    deleteKegCollectionRequestStatusState: {
      isDeleting: false,
      didDeleteSucceed: false,
      didDeleteFail: false,
    },
  },
  collectorsList: { content: [], isFetching: false, didFetchFail: false, didFetchSucceed: false },
  venuesList: { content: [], isFetching: false, didFetchFail: false, didFetchSucceed: false },
  selectedVenueCollectionInfo: {
    content: null,
    isFetching: false,
    didFetchFail: false,
    didFetchSucceed: false,
  },
  createKegCollectionRequestStatusState: {
    isCreating: false,
    didCreateSucceed: false,
    didCreateFail: false,
  },
  bookingsNotificationMessageState: {
    isShowing: false,
    header: '',
    content: '',
    isError: false,
  },
  bookingsModalErrorBannerState: {
    isShowing: false,
    header: '',
    content: '',
  },
}

export default (state = initialState, action) => {
  switch (action.type) {
    // BOOKINGS LIST ACTIONS - FETCH AND SAVE BOOKINGS LIST
    case FETCH_KEG_COLLECTION_BOOKINGS_REQUEST:
      return {
        ...state,
        bookingsList: {
          ...state.bookingsList,
          isFetching: true,
          didFetchSucceed: false,
          didFetchFail: false,
        },
      }
    case SAVE_KEG_COLLECTION_BOOKINGS:
      return {
        ...state,
        bookingsList: {
          ...state.bookingsList,
          content: action.payload.content || [],
          pageSize: action.payload.pageSize || 10,
          pageNumber: action.payload.pageNumber || 1,
          totalElements: action.payload.totalElements || 0,
          totalPages: action.payload.totalPages || 0,
        },
      }
    case FETCH_KEG_COLLECTION_BOOKINGS_SUCCESS: {
      const { params, fetchedAt } = action.payload || {}
      return {
        ...state,
        bookingsList: {
          ...state.bookingsList,
          fetchedAt: fetchedAt ?? Date.now(),
          lastParams: params || state.bookingsList.lastParams,
          isFetching: false,
          didFetchSucceed: true,
          didFetchFail: false,
        },
      }
    }
    case FETCH_KEG_COLLECTION_BOOKINGS_FAILURE:
      return {
        ...state,
        bookingsList: {
          ...state.bookingsList,
          isFetching: false,
          didFetchFail: true,
          didFetchSucceed: false,
        },
      }

    // BOOKINGS LIST VIEW SEARCH FILTER OPTIONS ACTIONS
    case SAVE_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS: {
      const { createdByUsers, assignedByUsers, states, postalCodes } = action?.payload
        ?.searchFilterOptions || {
        createdByUsers: [],
        assignedByUsers: [],
        states: [],
        postalCodes: [],
      }
      return {
        ...state,
        bookingsListViewSearchFilterOptions: {
          ...state.bookingsListViewSearchFilterOptions,
          content: {
            createdByUsers: createdByUsers.filter(Boolean),
            assignedByUsers: assignedByUsers.filter(Boolean),
            states: states.filter(Boolean),
            postalCodes: postalCodes.filter(Boolean),
          },
        },
      }
    }
    case FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_REQUEST:
      return {
        ...state,
        bookingsListViewSearchFilterOptions: {
          ...state.bookingsListViewSearchFilterOptions,
          isFetching: true,
          didFetchSucceed: false,
          didFetchFail: false,
        },
      }
    case FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_SUCCESS:
      return {
        ...state,
        bookingsListViewSearchFilterOptions: {
          ...state.bookingsListViewSearchFilterOptions,
          isFetching: false,
          didFetchSucceed: true,
          didFetchFail: false,
        },
      }
    case FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_FAILURE:
      return {
        ...state,
        bookingsListViewSearchFilterOptions: {
          ...state.bookingsListViewSearchFilterOptions,
          isFetching: false,
          didFetchSucceed: false,
          didFetchFail: true,
        },
      }

    // EXPORTED BOOKINGS LIST TO CSV
    case FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_REQUEST:
      return {
        ...state,
        bookingsExportList: {
          ...state.bookingsExportList,
          isFetching: true,
          didFetchSucceed: false,
          didFetchFail: false,
        },
      }
    case SAVE_EXPORTED_KEG_COLLECTION_BOOKINGS_CSV_FILE:
      return {
        ...state,
        bookingsExportList: {
          ...state.bookingsExportList,
          content: action.payload || [],
          isFetching: false,
          didFetchSucceed: true,
          didFetchFail: false,
        },
      }
    case FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_SUCCESS: {
      const { params, fetchedAt } = action.payload || {}
      return {
        ...state,
        bookingsExportList: {
          ...state.bookingsExportList,
          fetchedAt: fetchedAt ?? Date.now(),
          lastParams: params || state.bookingsExportList.lastParams,
          isFetching: false,
          didFetchSucceed: true,
          didFetchFail: false,
        },
      }
    }
    case FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_FAILURE: {
      return {
        ...state,
        bookingsExportList: {
          ...state.bookingsExportList,
          isFetching: false,
          didFetchFail: true,
          didFetchSucceed: false,
        },
      }
    }
    case RESET_EXPORTED_KEG_COLLECTION_BOOKINGS_CSV_FILE:
      return {
        ...state,
        bookingsExportList: {
          ...state.bookingsExportList,
          isFetching: false,
          didFetchSucceed: false,
          didFetchFail: false,
        },
      }

    // SINGLE BOOKING ACTIONS - FETCH AND SAVE SINGLE BOOKING
    case FETCH_SINGLE_KEG_COLLECTION_BOOKING_REQUEST:
      return {
        ...state,
        bookingDetails: {
          ...state.bookingDetails,
          bookingData: {
            ...state.bookingDetails.bookingData,
            isFetching: true,
            didFetchSucceed: false,
            didFetchFail: false,
          },
        },
      }
    case SAVE_SINGLE_KEG_COLLECTION_BOOKING:
      return {
        ...state,
        bookingDetails: {
          ...state.bookingDetails,
          bookingData: {
            ...state.bookingDetails.bookingData,
            content: action.payload || null,
          },
        },
      }
    case FETCH_SINGLE_KEG_COLLECTION_BOOKING_SUCCESS:
      return {
        ...state,
        bookingDetails: {
          ...state.bookingDetails,
          bookingData: {
            ...state.bookingDetails.bookingData,
            isFetching: false,
            didFetchSucceed: true,
            didFetchFail: false,
          },
        },
      }
    case FETCH_SINGLE_KEG_COLLECTION_BOOKING_FAILURE:
      return {
        ...state,
        bookingDetails: {
          ...state.bookingDetails,
          bookingData: {
            ...state.bookingDetails.bookingData,
            isFetching: false,
            didFetchSucceed: false,
            didFetchFail: true,
          },
        },
      }
    case KEG_COLLECTION_BOOKINGS_CURRENT_REQUEST_ID:
      return { ...state, bookingsList: { ...state.bookingsList, currentRequestId: action.payload } }

    // EDIT BOOKING ACTIONS - FETCH AND SAVE SINGLE EDITED BOOKING
    case EDIT_KEG_COLLECTION_BOOKING_REQUEST:
      return {
        ...state,
        bookingDetails: {
          ...state.bookingDetails,
          bookingData: {
            ...state.bookingDetails.bookingData,
            isEditing: true,
            didEditSucceed: false,
            didEditFail: false,
          },
        },
      }
    case SAVE_EDITED_KEG_COLLECTION_BOOKING:
      return {
        ...state,
        bookingDetails: {
          ...state.bookingDetails,
          bookingData: {
            ...state.bookingDetails.bookingData,
            content: action.payload.bookingDetails || null,
          },
        },
      }
    case EDIT_KEG_COLLECTION_BOOKING_SUCCESS:
      return {
        ...state,
        bookingsList: { ...state.bookingsList, content: [] },
        bookingDetails: {
          ...state.bookingDetails,
          bookingData: {
            ...state.bookingDetails.bookingData,
            isEditing: false,
            didEditSucceed: true,
            didEditFail: false,
          },
        },
      }
    case EDIT_KEG_COLLECTION_BOOKING_FAILURE:
      return {
        ...state,
        bookingDetails: {
          ...state.bookingDetails,
          bookingData: {
            ...state.bookingDetails.bookingData,
            isEditing: false,
            didEditSucceed: false,
            didEditFail: true,
          },
        },
      }
    case RESET_EDITED_BOOKING_STATUS_STATE:
      return {
        ...state,
        bookingDetails: {
          ...state.bookingDetails,
          bookingData: {
            ...state.bookingDetails.bookingData,
            isEditing: false,
            didEditSucceed: false,
            didEditFail: false,
          },
        },
      }

    // CREATE KEG COLLECTION REQUEST ACTIONS - CREATE NEW KEG COLLECTION REQUEST
    case CREATE_KEG_COLLECTION_REQUEST:
      return {
        ...state,
        createKegCollectionRequestStatusState: {
          isCreating: true,
          didCreateSucceed: false,
          didCreateFail: false,
        },
      }
    case CREATE_KEG_COLLECTION_SUCCESS:
      return {
        ...state,
        createKegCollectionRequestStatusState: {
          isCreating: false,
          didCreateSucceed: true,
          didCreateFail: false,
        },
      }
    case CREATE_KEG_COLLECTION_FAILURE:
      return {
        ...state,
        createKegCollectionRequestStatusState: {
          isCreating: false,
          didCreateSucceed: false,
          didCreateFail: true,
        },
      }
    case RESET_CREATE_KEG_COLLECTION_STATUS_STATE:
      return {
        ...state,
        venuesList: { content: [], isFetching: false, didFetchFail: false, didFetchSucceed: false },
        selectedVenueCollectionInfo: {
          content: null,
          isFetching: false,
          didFetchFail: false,
          didFetchSucceed: false,
        },
        createKegCollectionRequestStatusState: {
          isCreating: false,
          didCreateSucceed: false,
          didCreateFail: false,
        },
      }

    // EDIT KEG COLLECTION REQUEST ACTIONS
    case EDIT_KEG_COLLECTION_REQUEST_:
      return {
        ...state,
        bookingDetails: {
          ...state.bookingDetails,
          editKegCollectionRequestStatusState: {
            isEditing: true,
            didEditSucceed: false,
            didEditFail: false,
          },
        },
      }
    case SAVE_EDITED_KEG_COLLECTION:
      return {
        ...state,
        bookingsList: {
          ...state.bookingsList,
          content: [],
        },
        bookingDetails: {
          ...state.bookingDetails,
          bookingData: {
            ...state.bookingDetails.bookingData,
            content: null,
          },
        },
      }
    case EDIT_KEG_COLLECTION_REQUEST_SUCCESS:
      return {
        ...state,
        bookingDetails: {
          ...state.bookingDetails,
          editKegCollectionRequestStatusState: {
            isEditing: false,
            didEditSucceed: true,
            didEditFail: false,
          },
        },
      }
    case EDIT_KEG_COLLECTION_REQUEST_FAILURE:
      return {
        ...state,
        bookingDetails: {
          ...state.bookingDetails,
          editKegCollectionRequestStatusState: {
            isEditing: false,
            didEditSucceed: false,
            didEditFail: true,
          },
        },
      }
    case RESET_EDIT_KEG_COLLECTION_REQUEST_STATUS_STATE:
      return {
        ...state,
        bookingDetails: {
          ...state.bookingDetails,
          editKegCollectionRequestStatusState: {
            isEditing: false,
            didEditSucceed: false,
            didEditFail: false,
          },
        },
      }

    // DELETE KEG COLLECTION REQUEST ACTIONS
    case DELETE_KEG_COLLECTION_REQUEST:
      return {
        ...state,
        bookingDetails: {
          ...state.bookingDetails,
          deleteKegCollectionRequestStatusState: {
            isDeleting: true,
            didDeleteSucceed: false,
            didDeleteFail: false,
          },
        },
      }
    case DELETE_KEG_COLLECTION_SUCCESS:
      return {
        ...state,
        bookingsList: { ...state.bookingsList, content: [] },
        bookingDetails: {
          ...state.bookingDetails,
          bookingData: {
            ...state.bookingDetails.bookingData,
            content: null,
          },
          deleteKegCollectionRequestStatusState: {
            isDeleting: false,
            didDeleteSucceed: true,
            didDeleteFail: false,
          },
        },
      }
    case DELETE_KEG_COLLECTION_FAILURE:
      return {
        ...state,
        bookingDetails: {
          ...state.bookingDetails,
          deleteKegCollectionRequestStatusState: {
            isDeleting: false,
            didDeleteSucceed: false,
            didDeleteFail: true,
          },
        },
      }
    case RESET_DELETE_KEG_COLLECTION_STATUS_STATE:
      return {
        ...state,
        bookingDetails: {
          ...state.bookingDetails,
          deleteKegCollectionRequestStatusState: {
            isDeleting: false,
            didDeleteSucceed: false,
            didDeleteFail: false,
          },
        },
      }

    // COLLECTOR LIST ACTIONS
    case FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_REQUEST:
      return {
        ...state,
        collectorsList: {
          ...state.collectorsList,
          isFetching: true,
          didFetchSucceed: false,
          didFetchFail: false,
        },
      }
    case SAVE_KEG_COLLECTION_BOOKING_COLLECTORS:
      return {
        ...state,
        collectorsList: {
          ...state.collectorsList,
          content: action.payload.collectorsList || [],
        },
      }
    case FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_SUCCESS:
      return {
        ...state,
        collectorsList: {
          ...state.collectorsList,
          isFetching: false,
          didFetchSucceed: true,
          didFetchFail: false,
        },
      }
    case FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_FAILURE:
      return {
        ...state,
        collectorsList: {
          ...state.collectorsList,
          isFetching: false,
          didFetchFail: true,
          didFetchSucceed: false,
        },
      }

    // VENUE LIST ACTIONS
    case SAVE_KEG_COLLECTION_BOOKING_VENUES:
      return {
        ...state,
        venuesList: {
          ...state.venuesList,
          content: action.payload.venuesList || [],
        },
      }
    case FETCH_KEG_COLLECTION_BOOKING_VENUES_REQUEST:
      return {
        ...state,
        venuesList: {
          ...state.venuesList,
          isFetching: true,
          didFetchSucceed: false,
          didFetchFail: false,
        },
      }
    case FETCH_KEG_COLLECTION_BOOKING_VENUES_SUCCESS:
      return {
        ...state,
        venuesList: {
          ...state.venuesList,
          isFetching: false,
          didFetchSucceed: true,
          didFetchFail: false,
        },
      }
    case FETCH_KEG_COLLECTION_BOOKING_VENUES_FAILURE:
      return {
        ...state,
        venuesList: {
          ...state.venuesList,
          isFetching: false,
          didFetchSucceed: false,
          didFetchFail: true,
        },
      }

    // VENUE COLLECTION INFO ACTIONS
    case SAVE_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO:
      return {
        ...state,
        selectedVenueCollectionInfo: {
          ...state.selectedVenueCollectionInfo,
          content: action.payload.venueCollectionInfo,
        },
      }
    case FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_REQUEST:
      return {
        ...state,
        selectedVenueCollectionInfo: {
          ...state.selectedVenueCollectionInfo,
          isFetching: true,
          didFetchSucceed: false,
          didFetchFail: false,
        },
      }
    case FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_SUCCESS:
      return {
        ...state,
        selectedVenueCollectionInfo: {
          ...state.selectedVenueCollectionInfo,
          isFetching: false,
          didFetchSucceed: true,
          didFetchFail: false,
        },
      }
    case FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_FAILURE:
      return {
        ...state,
        selectedVenueCollectionInfo: {
          ...state.selectedVenueCollectionInfo,
          isFetching: false,
          didFetchSucceed: false,
          didFetchFail: true,
        },
      }

    // BOOKINGS GENERAL NOTIFICATION MESSAGE ACTIONS
    case SHOW_BOOKINGS_GENERAL_NOTIFICATION_MESSAGE:
      return {
        ...state,
        bookingsNotificationMessageState: {
          isShowing: true,
          header: action.payload?.header,
          content: action.payload?.content,
          isError: action.payload?.isError,
        },
      }
    case HIDE_BOOKINGS_GENERAL_NOTIFICATION_MESSAGE:
      return {
        ...state,
        bookingsNotificationMessageState: {
          ...state.bookingsNotificationMessageState,
          isShowing: false,
        },
      }

    // BOOKINGS MODAL ERROR BANNER ACTIONS
    case SHOW_BOOKINGS_MODAL_ERROR_MESSAGE:
      return {
        ...state,
        bookingsModalErrorBannerState: {
          isShowing: true,
          header: action.payload?.header,
          content: action.payload?.content,
        },
      }
    case HIDE_BOOKINGS_MODAL_ERROR_MESSAGE:
      return {
        ...state,
        bookingsModalErrorBannerState: {
          ...state.bookingsModalErrorBannerState,
          isShowing: false,
        },
      }

    default:
      return state
  }
}
